import ProductTypeTag from './productTypeTag';

export default ProductTypeTag;
